import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const ProcedureTypesViewTopBar = memo(() => {
	return <BaseTopBar />
})
ProcedureTypesViewTopBar.displayName = "ProcedureTypesViewTopBar"
